//
//
//
//
//
//
//
//

    export default {
        name: 'App',
        methods: {}
    }



// WEBPACK FOOTER //
// ./src/App.vue